import axios from "axios";
import React, { useState, useRef, useEffect } from "react";
import LoadingOverlay from 'react-loading-overlay'

function Generales() {
  const API_URL = process.env.REACT_APP_API_URL

  const [spinnerIsActive, setSpinnerIsActive] = useState(false)
  const [showAlertSuccess, setShowAlertSuccess] = useState(false)

  const clearTimerRef = useRef()

  const getGeneralElements = () => {
    axios.get(API_URL + '/elementos-generales').then(
      (response) => {
        let elements = response.data.data

        for (let key in elements) {
          switch(elements[key].idElemento) {
            case 'link-instagram':
              document.getElementById('link-instagram').value = elements[key].url;
              break;

            case 'link-facebook':
              document.getElementById('link-facebook').value = elements[key].url;
              break;

            default:
              break;
          }
        }
      }
    ).catch((error) => console.error("ERROR: " + error))
  }

  const updateGeneralElement = (elementName) => {
    setSpinnerIsActive(true)
    setShowAlertSuccess(false)
    clearTimeout(clearTimerRef.current)

    let data = []
    
    const elementNameText = elementName
    const contentText = document.getElementById(elementName).value

    data = {
      name: elementNameText,
      content: contentText,
    }

    axios.post(API_URL + "/update-elementos-generales", data, {}).then(
      (res) => {
        setSpinnerIsActive(false)
        setShowAlertSuccess(true)

        clearTimerRef.current = setTimeout(function () {
          setShowAlertSuccess(false)
        }, 3000)
      },
      (error) => {
        alert(error)
      }
    )
  }

  useEffect(() => {
    getGeneralElements()
  }, [])

  return (
    <>
      <LoadingOverlay active={spinnerIsActive} spinner text='Cargando...'>
        <div className="row g-5">
          <div className="col-lg-12">
            <div className="card card-custom card-stretch shadow mb-5">
              <div className="card-header">
                <h3 className="card-title">Elementos generales</h3>
              </div>
              <div className="card-body">
                <h2 className="mb-2">Enlaces redes sociales</h2>

                <div className="row mb-2">
                  <div className="form-group col-md-10">
                    <label>Instagram:</label>
                    <input type="text" className="form-control" id="link-instagram" />
                  </div>
                  <div className="col-md-2 mt-6 float-end">
                    <button type="button" className="btn btn-primary" onClick={() => updateGeneralElement('link-instagram')}>Guardar</button>
                  </div>
                </div>

                <div className="row mb-2">
                  <div className="form-group col-md-10">
                    <label>Facebook:</label>
                    <input type="text" className="form-control" id="link-facebook" />
                  </div>
                  <div className="col-md-2 mt-6 float-end">
                    <button type="button" className="btn btn-primary" onClick={() => updateGeneralElement('link-facebook')}>Guardar</button>
                  </div>
                </div>

                <div className="row mb-2">
                  <div className="form-group col-md-10">
                    <label>LinkedIn:</label>
                    <input type="text" className="form-control" id="link-linkedin" />
                  </div>
                  <div className="col-md-2 mt-6 float-end">
                    <button type="button" className="btn btn-primary" onClick={() => updateGeneralElement('link-linkedin')}>Guardar</button>
                  </div>
                </div>

                <div className="row mb-2">
                  <div className="form-group col-md-10">
                    <label>TikTok:</label>
                    <input type="text" className="form-control" id="link-tiktok" />
                  </div>
                  <div className="col-md-2 mt-6 float-end">
                    <button type="button" className="btn btn-primary" onClick={() => updateGeneralElement('link-tiktok')}>Guardar</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </LoadingOverlay>
      <div className="row alert-container">
        {showAlertSuccess ? (
          <div className='alert alert-success alert-dismissible bg-success d-flex flex-column flex-sm-row p-5 mb-10 col-md-6'>
            <span className='svg-icon svg-icon-2hx svg-icon-light me-4 mb-5 mb-sm-0'>
              <svg
                width='24'
                height='24'
                viewBox='0 0 24 24'
                fill='none'
                xmlns='http://www.w3.org/2000/svg'
                class='mh-50px'
              >
                <path
                  opacity='0.3'
                  d='M12 22C13.6569 22 15 20.6569 15 19C15 17.3431 13.6569 16 12 16C10.3431 16 9 17.3431 9 19C9 20.6569 10.3431 22 12 22Z'
                  fill='black'
                ></path>
                <path
                  d='M19 15V18C19 18.6 18.6 19 18 19H6C5.4 19 5 18.6 5 18V15C6.1 15 7 14.1 7 13V10C7 7.6 8.7 5.6 11 5.1V3C11 2.4 11.4 2 12 2C12.6 2 13 2.4 13 3V5.1C15.3 5.6 17 7.6 17 10V13C17 14.1 17.9 15 19 15ZM11 10C11 9.4 11.4 9 12 9C12.6 9 13 8.6 13 8C13 7.4 12.6 7 12 7C10.3 7 9 8.3 9 10C9 10.6 9.4 11 10 11C10.6 11 11 10.6 11 10Z'
                  fill='black'
                ></path>
              </svg>
            </span>
            <div className='d-flex flex-column text-light pe-0 pe-sm-10'>
              <h3 className='mb-1'>Cambios guardados con éxito</h3>
            </div>
          </div>
        ) : (
          <div></div>
        )}{' '}
      </div>
    </>
  )
}

export {Generales}